// extracted by mini-css-extract-plugin
export default {"EditeUserDiv":"EditeUser_EditeUserDiv__9-OpG","title":"EditeUser_title__CfyY7","InputsDiv":"EditeUser_InputsDiv__PKfXN"};